export default async function lazysizes() {
    await import('lazysizes');
    attachEventListeners();
}

function attachEventListeners() {
    document.addEventListener('lazyloaded', function (e) {
        e.target.style.background = '';
    });
}
